import { usePathname } from "next/navigation";
import { useMemo } from "react";

const giftCardsPathRegex = /^\/gift-cards\/?/i;
export const useIsGiftCardsPage = () => {
    const path = usePathname();

    const isGiftCards = useMemo(() => giftCardsPathRegex.test(path), [path]);
    return isGiftCards;
};

const specificGiftCardLineLocales = ["en-AU", "en-NZ"];

export const useShowSpecificGiftCardLine = (currentLocale: string) => {
    const isGiftCardsPage = useIsGiftCardsPage();
    const inSpecificLocale = useMemo(
        () => specificGiftCardLineLocales.includes(currentLocale),
        [currentLocale]
    );
    return isGiftCardsPage && inSpecificLocale;
};
